module.exports = __webpack_public_path__ + "static/media/apx.8a905a8b.svg";